import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TwoFactorService } from '../services/two-factor.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-two-factor-setup',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule
  ],
  templateUrl: './two-factor-setup.component.html',
  styleUrl: './two-factor-setup.component.scss'
})
export class TwoFactorSetupComponent implements OnDestroy {

  qrCode: string | null = null;
  token = '';
  verificationResult: boolean | null = null;

  destroy$ = new Subject<void>();

  secretEnabled = false;

  constructor(
    private router: Router,
    private twoFactorService: TwoFactorService) {

    this.twoFactorService.generate2fa$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.onGenerate();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Запрос генерации секрета и QR-кода
  onGenerate() {
    this.twoFactorService.generate2FA()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      res => {
        if(res.secretEnabled){
          this.secretEnabled = res.secretEnabled;
        } else {
          this.qrCode = res.qr;
        }
      },
      err => {
        console.error('Ошибка генерации 2FA', err);
      }
    );
  }

  // Отправка токена на верификацию
  onVerify() {
    this.twoFactorService.verify2FA(this.token)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      res => {
        this.verificationResult = res.verified;
        if(this.verificationResult){
          this.router.navigateByUrl('/search').then();
        }
      },
      err => {
        this.verificationResult = false;
      }
    );
  }
}
